import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable()
export class EventTimelineSyncService {
  public readonly eventPersonasRefreshRequested$ = new Subject<number>()
  public pendingEventPersonasRefresh: number | null = null

  /**
   * Ask the events timeline to reload personas for an event without refreshing the full list.
   */
  public requestEventPersonasRefresh(eventId: number): void {
    this.pendingEventPersonasRefresh = eventId
    this.eventPersonasRefreshRequested$.next(eventId)
  }
}
